export default [{
  countryName: 'Afghanistan',
  copyKey: 'COUNTRY_AF',
  isoCode: 'AF',
  regionCode: 'MID',
  sequence: 99
}, {
  countryName: 'Albania',
  copyKey: 'COUNTRY_AL',
  isoCode: 'AL',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Algeria',
  copyKey: 'COUNTRY_DZ',
  isoCode: 'DZ',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'American Samoa',
  copyKey: 'COUNTRY_AS',
  isoCode: 'AS',
  regionCode: 'AUS',
  sequence: 99
}, {
  countryName: 'Andorra',
  copyKey: 'COUNTRY_AD',
  isoCode: 'AD',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Angola',
  copyKey: 'COUNTRY_AO',
  isoCode: 'AO',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Anguilla/St Kitts',
  copyKey: 'COUNTRY_AI',
  isoCode: 'AI',
  regionCode: 'CAR',
  sequence: 99
}, {
  countryName: 'Antarctica',
  copyKey: 'COUNTRY_AQ',
  isoCode: 'AQ',
  regionCode: 'OTH',
  sequence: 99
}, {
  countryName: 'Antigua and Barbuda',
  copyKey: 'COUNTRY_AG',
  isoCode: 'AG',
  regionCode: 'CAR',
  sequence: 99
}, {
  countryName: 'Argentina',
  copyKey: 'COUNTRY_AR',
  isoCode: 'AR',
  regionCode: 'SAM',
  sequence: 99
}, {
  countryName: 'Armenia',
  copyKey: 'COUNTRY_AM',
  isoCode: 'AM',
  regionCode: 'MID',
  sequence: 99
}, {
  countryName: 'Aruba',
  copyKey: 'COUNTRY_AW',
  isoCode: 'AW',
  regionCode: 'CAR',
  sequence: 99
}, {
  countryName: 'Australia',
  copyKey: 'COUNTRY_AU',
  isoCode: 'AU',
  regionCode: 'AUS',
  sequence: 99
}, {
  countryName: 'Austria',
  copyKey: 'COUNTRY_AT',
  isoCode: 'AT',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Azerbaijan',
  copyKey: 'COUNTRY_AZ',
  isoCode: 'AZ',
  regionCode: 'MID',
  sequence: 99
}, {
  countryName: 'Bahamas',
  copyKey: 'COUNTRY_BS',
  isoCode: 'BS',
  regionCode: 'CAR',
  sequence: 99
}, {
  countryName: 'Bahrain',
  copyKey: 'COUNTRY_BH',
  isoCode: 'BH',
  regionCode: 'MID',
  sequence: 99
}, {
  countryName: 'Bangladesh',
  copyKey: 'COUNTRY_BD',
  isoCode: 'BD',
  regionCode: 'ASI',
  sequence: 99
}, {
  countryName: 'Barbados',
  copyKey: 'COUNTRY_BB',
  isoCode: 'BB',
  regionCode: 'CAR',
  sequence: 99
}, {
  countryName: 'Belarus',
  copyKey: 'COUNTRY_BY',
  isoCode: 'BY',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Belgium',
  copyKey: 'COUNTRY_BE',
  isoCode: 'BE',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Belize',
  copyKey: 'COUNTRY_BZ',
  isoCode: 'BZ',
  regionCode: 'CEA',
  sequence: 99
}, {
  countryName: 'Benin',
  copyKey: 'COUNTRY_BJ',
  isoCode: 'BJ',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Bermuda',
  copyKey: 'COUNTRY_BM',
  isoCode: 'BM',
  regionCode: 'CAR',
  sequence: 99
}, {
  countryName: 'Bhutan',
  copyKey: 'COUNTRY_BT',
  isoCode: 'BT',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Bolivia',
  copyKey: 'COUNTRY_BO',
  isoCode: 'BO',
  regionCode: 'CEA',
  sequence: 99
}, {
  countryName: 'Bonaire,Saba,St Eustatius',
  copyKey: 'COUNTRY_BQ',
  isoCode: 'BQ',
  regionCode: 'CAR',
  sequence: 99
}, {
  countryName: 'Bosnia Herzegovina',
  copyKey: 'COUNTRY_BA',
  isoCode: 'BA',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Botswana',
  copyKey: 'COUNTRY_BW',
  isoCode: 'BW',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Bouvet Island',
  copyKey: 'COUNTRY_BV',
  isoCode: 'BV',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Brazil',
  copyKey: 'COUNTRY_BR',
  isoCode: 'BR',
  regionCode: 'SAM',
  sequence: 99
}, {
  countryName: 'British Indian Ocean Territory',
  copyKey: 'COUNTRY_IO',
  isoCode: 'IO',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Brunei Darussalam',
  copyKey: 'COUNTRY_BN',
  isoCode: 'BN',
  regionCode: 'ASI',
  sequence: 99
}, {
  countryName: 'Bulgaria',
  copyKey: 'COUNTRY_BG',
  isoCode: 'BG',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Burkina Fasa',
  copyKey: 'COUNTRY_BF',
  isoCode: 'BF',
  regionCode: 'ASI',
  sequence: 99
}, {
  countryName: 'Burundi',
  copyKey: 'COUNTRY_BI',
  isoCode: 'BI',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Cambodia',
  copyKey: 'COUNTRY_KH',
  isoCode: 'KH',
  regionCode: 'ASI',
  sequence: 99
}, {
  countryName: 'Cameroon',
  copyKey: 'COUNTRY_CM',
  isoCode: 'CM',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Canada',
  copyKey: 'COUNTRY_CA',
  isoCode: 'CA',
  regionCode: 'NAM',
  sequence: 99
}, {
  countryName: 'Cape Verde',
  copyKey: 'COUNTRY_CV',
  isoCode: 'CV',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Cayman Islands',
  copyKey: 'COUNTRY_KY',
  isoCode: 'KY',
  regionCode: 'CAR',
  sequence: 99
}, {
  countryName: 'Central African Republic',
  copyKey: 'COUNTRY_CF',
  isoCode: 'CF',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Chad',
  copyKey: 'COUNTRY_TD',
  isoCode: 'TD',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Chile',
  copyKey: 'COUNTRY_CL',
  isoCode: 'CL',
  regionCode: 'SAM',
  sequence: 99
}, {
  countryName: 'China',
  copyKey: 'COUNTRY_CN',
  isoCode: 'CN',
  regionCode: 'ASI',
  sequence: 99
}, {
  countryName: 'Christmas Island',
  copyKey: 'COUNTRY_CX',
  isoCode: 'CX',
  regionCode: 'AUS',
  sequence: 99
}, {
  countryName: 'Cocos (Keeling) Islands',
  copyKey: 'COUNTRY_CC',
  isoCode: 'CC',
  regionCode: 'AUS',
  sequence: 99
}, {
  countryName: 'Colombia',
  copyKey: 'COUNTRY_CO',
  isoCode: 'CO',
  regionCode: 'SAM',
  sequence: 99
}, {
  countryName: 'Comoros',
  copyKey: 'COUNTRY_KM',
  isoCode: 'KM',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Congo',
  copyKey: 'COUNTRY_CG',
  isoCode: 'CG',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Congo, The Democratic Republic of the',
  copyKey: 'COUNTRY_CD',
  isoCode: 'CD',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Cook Island',
  copyKey: 'COUNTRY_CK',
  isoCode: 'CK',
  regionCode: 'AUS',
  sequence: 99
}, {
  countryName: 'Costa Rica',
  copyKey: 'COUNTRY_CR',
  isoCode: 'CR',
  regionCode: 'CEA',
  sequence: 99
}, {
  countryName: 'Cote D\'Ivoire',
  copyKey: 'COUNTRY_CI',
  isoCode: 'CI',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Croatia',
  copyKey: 'COUNTRY_HR',
  isoCode: 'HR',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Cuba',
  copyKey: 'COUNTRY_CU',
  isoCode: 'CU',
  regionCode: 'CAR',
  sequence: 99
}, {
  countryName: 'Curacao',
  copyKey: 'COUNTRY_CW',
  isoCode: 'CW',
  regionCode: 'CAR',
  sequence: 99
}, {
  countryName: 'Cyprus',
  copyKey: 'COUNTRY_CY',
  isoCode: 'CY',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Czech Republic',
  copyKey: 'COUNTRY_CZ',
  isoCode: 'CZ',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Denmark',
  copyKey: 'COUNTRY_DK',
  isoCode: 'DK',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Djibouti',
  copyKey: 'COUNTRY_DJ',
  isoCode: 'DJ',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Dominica',
  copyKey: 'COUNTRY_DM',
  isoCode: 'DM',
  regionCode: 'SAM',
  sequence: 99
}, {
  countryName: 'Dominican Republic',
  copyKey: 'COUNTRY_DO',
  isoCode: 'DO',
  regionCode: 'CAR',
  sequence: 99
}, {
  countryName: 'East Timor',
  copyKey: 'COUNTRY_TP',
  isoCode: 'TP',
  regionCode: 'ASI',
  sequence: 99
}, {
  countryName: 'Ecuador',
  copyKey: 'COUNTRY_EC',
  isoCode: 'EC',
  regionCode: 'CEA',
  sequence: 99
}, {
  countryName: 'Egypt',
  copyKey: 'COUNTRY_EG',
  isoCode: 'EG',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'El Salvador',
  copyKey: 'COUNTRY_SV',
  isoCode: 'SV',
  regionCode: 'CEA',
  sequence: 99
}, {
  countryName: 'Equatorial Guinea',
  copyKey: 'COUNTRY_GQ',
  isoCode: 'GQ',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Eritrea',
  copyKey: 'COUNTRY_ER',
  isoCode: 'ER',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Estonia',
  copyKey: 'COUNTRY_EE',
  isoCode: 'EE',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Ethiopia',
  copyKey: 'COUNTRY_ET',
  isoCode: 'ET',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Falkland Islands',
  copyKey: 'COUNTRY_FK',
  isoCode: 'FK',
  regionCode: 'SAM',
  sequence: 99
}, {
  countryName: 'Faroe Islands',
  copyKey: 'COUNTRY_FO',
  isoCode: 'FO',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Fiji',
  copyKey: 'COUNTRY_FJ',
  isoCode: 'FJ',
  regionCode: 'AUS',
  sequence: 99
}, {
  countryName: 'Finland',
  copyKey: 'COUNTRY_FI',
  isoCode: 'FI',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'France',
  copyKey: 'COUNTRY_FR',
  isoCode: 'FR',
  regionCode: 'EUR',
  sequence: 5
}, {
  countryName: 'French Guiana',
  copyKey: 'COUNTRY_GF',
  isoCode: 'GF',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'French Polynesia',
  copyKey: 'COUNTRY_PF',
  isoCode: 'PF',
  regionCode: 'AUS',
  sequence: 99
}, {
  countryName: 'French Souther Territories',
  copyKey: 'COUNTRY_TF',
  isoCode: 'TF',
  regionCode: 'CAR',
  sequence: 99
}, {
  countryName: 'Gabon',
  copyKey: 'COUNTRY_GA',
  isoCode: 'GA',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Gambia',
  copyKey: 'COUNTRY_GM',
  isoCode: 'GM',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Georgia',
  copyKey: 'COUNTRY_GE',
  isoCode: 'GE',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Germany',
  copyKey: 'COUNTRY_DE',
  isoCode: 'DE',
  regionCode: 'EUR',
  sequence: 4
}, {
  countryName: 'Ghana',
  copyKey: 'COUNTRY_GH',
  isoCode: 'GH',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Gibraltar',
  copyKey: 'COUNTRY_GI',
  isoCode: 'GI',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Greece',
  copyKey: 'COUNTRY_GR',
  isoCode: 'GR',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Greenland',
  copyKey: 'COUNTRY_GL',
  isoCode: 'GL',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Grenada',
  copyKey: 'COUNTRY_GD',
  isoCode: 'GD',
  regionCode: 'CEA',
  sequence: 99
}, {
  countryName: 'Guadeloupe/St Martin',
  copyKey: 'COUNTRY_GP',
  isoCode: 'GP',
  regionCode: 'CAR',
  sequence: 99
}, {
  countryName: 'Guam',
  copyKey: 'COUNTRY_GU',
  isoCode: 'GU',
  regionCode: 'MIC',
  sequence: 99
}, {
  countryName: 'Guatemala',
  copyKey: 'COUNTRY_GT',
  isoCode: 'GT',
  regionCode: 'SAM',
  sequence: 99
}, {
  countryName: 'Guinea',
  copyKey: 'COUNTRY_GN',
  isoCode: 'GN',
  regionCode: 'ASI',
  sequence: 99
}, {
  countryName: 'Guinea Bissau',
  copyKey: 'COUNTRY_GW',
  isoCode: 'GW',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Guyana',
  copyKey: 'COUNTRY_GY',
  isoCode: 'GY',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Haiti',
  copyKey: 'COUNTRY_HT',
  isoCode: 'HT',
  regionCode: 'CAR',
  sequence: 99
}, {
  countryName: 'Heard and McDonald Islands',
  copyKey: 'COUNTRY_HM',
  isoCode: 'HM',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Honduras',
  copyKey: 'COUNTRY_HN',
  isoCode: 'HN',
  regionCode: 'CEA',
  sequence: 99
}, {
  countryName: 'Hong Kong',
  copyKey: 'COUNTRY_HK',
  isoCode: 'HK',
  regionCode: 'ASI',
  sequence: 99
}, {
  countryName: 'Hungary',
  copyKey: 'COUNTRY_HU',
  isoCode: 'HU',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Iceland',
  copyKey: 'COUNTRY_IS',
  isoCode: 'IS',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'India',
  copyKey: 'COUNTRY_IN',
  isoCode: 'IN',
  regionCode: 'ASI',
  sequence: 99
}, {
  countryName: 'Indonesia',
  copyKey: 'COUNTRY_ID',
  isoCode: 'ID',
  regionCode: 'ASI',
  sequence: 99
}, {
  countryName: 'Iran',
  copyKey: 'COUNTRY_IR',
  isoCode: 'IR',
  regionCode: 'MID',
  sequence: 99
}, {
  countryName: 'Iraq',
  copyKey: 'COUNTRY_IQ',
  isoCode: 'IQ',
  regionCode: 'MID',
  sequence: 99
}, {
  countryName: 'Ireland',
  copyKey: 'COUNTRY_IE',
  isoCode: 'IE',
  regionCode: 'EUR',
  sequence: 1
}, {
  countryName: 'Isle Of Man',
  copyKey: 'COUNTRY_IM',
  isoCode: 'IM',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Israel',
  copyKey: 'COUNTRY_IL',
  isoCode: 'IL',
  regionCode: 'MID',
  sequence: 99
}, {
  countryName: 'Italy',
  copyKey: 'COUNTRY_IT',
  isoCode: 'IT',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Jamaica',
  copyKey: 'COUNTRY_JM',
  isoCode: 'JM',
  regionCode: 'CAR',
  sequence: 99
}, {
  countryName: 'Japan',
  copyKey: 'COUNTRY_JP',
  isoCode: 'JP',
  regionCode: 'ASI',
  sequence: 99
}, {
  countryName: 'Jordan',
  copyKey: 'COUNTRY_JO',
  isoCode: 'JO',
  regionCode: 'MID',
  sequence: 99
}, {
  countryName: 'Kazakhstan',
  copyKey: 'COUNTRY_KZ',
  isoCode: 'KZ',
  regionCode: 'MID',
  sequence: 99
}, {
  countryName: 'Kenya',
  copyKey: 'COUNTRY_KE',
  isoCode: 'KE',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Kiribati',
  copyKey: 'COUNTRY_KI',
  isoCode: 'KI',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Kuwait',
  copyKey: 'COUNTRY_KW',
  isoCode: 'KW',
  regionCode: 'MID',
  sequence: 99
}, {
  countryName: 'Kyrgzstan',
  copyKey: 'COUNTRY_KG',
  isoCode: 'KG',
  regionCode: 'MID',
  sequence: 99
}, {
  countryName: 'Laos',
  copyKey: 'COUNTRY_LA',
  isoCode: 'LA',
  regionCode: 'ASI',
  sequence: 99
}, {
  countryName: 'Latvia',
  copyKey: 'COUNTRY_LV',
  isoCode: 'LV',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Lebanon',
  copyKey: 'COUNTRY_LB',
  isoCode: 'LB',
  regionCode: 'MID',
  sequence: 99
}, {
  countryName: 'Lesotho',
  copyKey: 'COUNTRY_LS',
  isoCode: 'LS',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Liberia',
  copyKey: 'COUNTRY_LR',
  isoCode: 'LR',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Libyan Arab Jamahiriya',
  copyKey: 'COUNTRY_LY',
  isoCode: 'LY',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Liechtenstein',
  copyKey: 'COUNTRY_LI',
  isoCode: 'LI',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Lithuania',
  copyKey: 'COUNTRY_LT',
  isoCode: 'LT',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Luxembourg',
  copyKey: 'COUNTRY_LU',
  isoCode: 'LU',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Macau',
  copyKey: 'COUNTRY_MO',
  isoCode: 'MO',
  regionCode: 'ASI',
  sequence: 99
}, {
  countryName: 'Macedonia',
  copyKey: 'COUNTRY_MK',
  isoCode: 'MK',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Madagascar',
  copyKey: 'COUNTRY_MG',
  isoCode: 'MG',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Malawi',
  copyKey: 'COUNTRY_MW',
  isoCode: 'MW',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Malaysia',
  copyKey: 'COUNTRY_MY',
  isoCode: 'MY',
  regionCode: 'ASI',
  sequence: 99
}, {
  countryName: 'Maldives',
  copyKey: 'COUNTRY_MV',
  isoCode: 'MV',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Mali',
  copyKey: 'COUNTRY_ML',
  isoCode: 'ML',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Malta',
  copyKey: 'COUNTRY_MT',
  isoCode: 'MT',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Marshall Islands',
  copyKey: 'COUNTRY_MH',
  isoCode: 'MH',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Martinique',
  copyKey: 'COUNTRY_MQ',
  isoCode: 'MQ',
  regionCode: 'CAR',
  sequence: 99
}, {
  countryName: 'Mauritania',
  copyKey: 'COUNTRY_MR',
  isoCode: 'MR',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Mauritius',
  copyKey: 'COUNTRY_MU',
  isoCode: 'MU',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Mayotte',
  copyKey: 'COUNTRY_YT',
  isoCode: 'YT',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Mexico',
  copyKey: 'COUNTRY_MX',
  isoCode: 'MX',
  regionCode: 'CEA',
  sequence: 99
}, {
  countryName: 'Micronesia, Federated States of',
  copyKey: 'COUNTRY_FM',
  isoCode: 'FM',
  regionCode: 'MIC',
  sequence: 99
}, {
  countryName: 'Midway Islands',
  copyKey: 'COUNTRY_MI',
  isoCode: 'MI',
  regionCode: 'AUS',
  sequence: 99
}, {
  countryName: 'Moldova',
  copyKey: 'COUNTRY_MD',
  isoCode: 'MD',
  regionCode: 'MID',
  sequence: 99
}, {
  countryName: 'Monaco',
  copyKey: 'COUNTRY_MC',
  isoCode: 'MC',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Mongolia',
  copyKey: 'COUNTRY_MN',
  isoCode: 'MN',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Montenegro',
  copyKey: 'COUNTRY_ME',
  isoCode: 'ME',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Montserrat',
  copyKey: 'COUNTRY_MS',
  isoCode: 'MS',
  regionCode: 'CAR',
  sequence: 99
}, {
  countryName: 'Morocco',
  copyKey: 'COUNTRY_MA',
  isoCode: 'MA',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Mozambique',
  copyKey: 'COUNTRY_MZ',
  isoCode: 'MZ',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Myanmar',
  copyKey: 'COUNTRY_MM',
  isoCode: 'MM',
  regionCode: 'ASI',
  sequence: 99
}, {
  countryName: 'Namibia',
  copyKey: 'COUNTRY_NA',
  isoCode: 'NA',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Nauru',
  copyKey: 'COUNTRY_NR',
  isoCode: 'NR',
  regionCode: 'AUS',
  sequence: 99
}, {
  countryName: 'Nepal',
  copyKey: 'COUNTRY_NP',
  isoCode: 'NP',
  regionCode: 'ASI',
  sequence: 99
}, {
  countryName: 'Netherlands',
  copyKey: 'COUNTRY_NL',
  isoCode: 'NL',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Netherlands Antilles',
  copyKey: 'COUNTRY_AN',
  isoCode: 'AN',
  regionCode: 'CAR',
  sequence: 99
}, {
  countryName: 'New Caledonia',
  copyKey: 'COUNTRY_NC',
  isoCode: 'NC',
  regionCode: 'AUS',
  sequence: 99
}, {
  countryName: 'New Zealand',
  copyKey: 'COUNTRY_NZ',
  isoCode: 'NZ',
  regionCode: 'AUS',
  sequence: 99
}, {
  countryName: 'Nicaragua',
  copyKey: 'COUNTRY_NI',
  isoCode: 'NI',
  regionCode: 'CEA',
  sequence: 99
}, {
  countryName: 'Niger',
  copyKey: 'COUNTRY_NE',
  isoCode: 'NE',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Nigeria',
  copyKey: 'COUNTRY_NG',
  isoCode: 'NG',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Niue',
  copyKey: 'COUNTRY_NU',
  isoCode: 'NU',
  regionCode: 'AUS',
  sequence: 99
}, {
  countryName: 'Norfolk Island',
  copyKey: 'COUNTRY_NF',
  isoCode: 'NF',
  regionCode: 'AUS',
  sequence: 99
}, {
  countryName: 'North Korea',
  copyKey: 'COUNTRY_KP',
  isoCode: 'KP',
  regionCode: 'ASI',
  sequence: 99
}, {
  countryName: 'Northern Mariana Islands',
  copyKey: 'COUNTRY_MP',
  isoCode: 'MP',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Norway',
  copyKey: 'COUNTRY_NO',
  isoCode: 'NO',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Oman',
  copyKey: 'COUNTRY_OM',
  isoCode: 'OM',
  regionCode: 'MID',
  sequence: 99
}, {
  countryName: 'Pakistan',
  copyKey: 'COUNTRY_PK',
  isoCode: 'PK',
  regionCode: 'ASI',
  sequence: 99
}, {
  countryName: 'Palau',
  copyKey: 'COUNTRY_PW',
  isoCode: 'PW',
  regionCode: 'MIC',
  sequence: 99
}, {
  countryName: 'Panama',
  copyKey: 'COUNTRY_PA',
  isoCode: 'PA',
  regionCode: 'CEA',
  sequence: 99
}, {
  countryName: 'Papua New Guinea',
  copyKey: 'COUNTRY_PG',
  isoCode: 'PG',
  regionCode: 'ASI',
  sequence: 99
}, {
  countryName: 'Paraguay',
  copyKey: 'COUNTRY_PY',
  isoCode: 'PY',
  regionCode: 'SAM',
  sequence: 99
}, {
  countryName: 'Peru',
  copyKey: 'COUNTRY_PE',
  isoCode: 'PE',
  regionCode: 'SAM',
  sequence: 99
}, {
  countryName: 'Philippines',
  copyKey: 'COUNTRY_PH',
  isoCode: 'PH',
  regionCode: 'ASI',
  sequence: 99
}, {
  countryName: 'Pitcairn',
  copyKey: 'COUNTRY_PN',
  isoCode: 'PN',
  regionCode: 'OTH',
  sequence: 99
}, {
  countryName: 'Poland',
  copyKey: 'COUNTRY_PL',
  isoCode: 'PL',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Portugal',
  copyKey: 'COUNTRY_PT',
  isoCode: 'PT',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Puerto Rico',
  copyKey: 'COUNTRY_PR',
  isoCode: 'PR',
  regionCode: 'CAR',
  sequence: 99
}, {
  countryName: 'Qatar',
  copyKey: 'COUNTRY_QA',
  isoCode: 'QA',
  regionCode: 'MID',
  sequence: 99
}, {
  countryName: 'Reunion',
  copyKey: 'COUNTRY_RE',
  isoCode: 'RE',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Romania',
  copyKey: 'COUNTRY_RO',
  isoCode: 'RO',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Russia',
  copyKey: 'COUNTRY_RU',
  isoCode: 'RU',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Russian Federation',
  copyKey: 'COUNTRY_RQ',
  isoCode: 'RQ',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Rwanda',
  copyKey: 'COUNTRY_RW',
  isoCode: 'RW',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Saint Helena',
  copyKey: 'COUNTRY_SH',
  isoCode: 'SH',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Saint Kitts and Nevis',
  copyKey: 'COUNTRY_KN',
  isoCode: 'KN',
  regionCode: 'CAR',
  sequence: 99
}, {
  countryName: 'Saint Lucia',
  copyKey: 'COUNTRY_LC',
  isoCode: 'LC',
  regionCode: 'CAR',
  sequence: 99
}, {
  countryName: 'Saint Pierre And Miquelon',
  copyKey: 'COUNTRY_PM',
  isoCode: 'PM',
  regionCode: 'NAM',
  sequence: 99
}, {
  countryName: 'Saint Vincent And The Grenadines',
  copyKey: 'COUNTRY_VC',
  isoCode: 'VC',
  regionCode: 'CAR',
  sequence: 99
}, {
  countryName: 'Samoa',
  copyKey: 'COUNTRY_WS',
  isoCode: 'WS',
  regionCode: 'AUS',
  sequence: 99
}, {
  countryName: 'San Marino',
  copyKey: 'COUNTRY_SM',
  isoCode: 'SM',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Sao Tome and Principe',
  copyKey: 'COUNTRY_ST',
  isoCode: 'ST',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Saudi Arabia',
  copyKey: 'COUNTRY_SA',
  isoCode: 'SA',
  regionCode: 'MID',
  sequence: 99
}, {
  countryName: 'Senegal',
  copyKey: 'COUNTRY_SN',
  isoCode: 'SN',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Serbia',
  copyKey: 'COUNTRY_RS',
  isoCode: 'RS',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Seychelles',
  copyKey: 'COUNTRY_SC',
  isoCode: 'SC',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Sierra Leone',
  copyKey: 'COUNTRY_SL',
  isoCode: 'SL',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Singapore',
  copyKey: 'COUNTRY_SG',
  isoCode: 'SG',
  regionCode: 'ASI',
  sequence: 99
}, {
  countryName: 'Sint Maarten',
  copyKey: 'COUNTRY_SX',
  isoCode: 'SX',
  regionCode: 'CAR',
  sequence: 99
}, {
  countryName: 'Slovakia',
  copyKey: 'COUNTRY_SK',
  isoCode: 'SK',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Slovenia',
  copyKey: 'COUNTRY_SI',
  isoCode: 'SI',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Solomon Islands',
  copyKey: 'COUNTRY_SB',
  isoCode: 'SB',
  regionCode: 'AUS',
  sequence: 99
}, {
  countryName: 'Somalia',
  copyKey: 'COUNTRY_SO',
  isoCode: 'SO',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'South Africa',
  copyKey: 'COUNTRY_ZA',
  isoCode: 'ZA',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'South Georgia and the South Sandwich Islands',
  copyKey: 'COUNTRY_GS',
  isoCode: 'GS',
  regionCode: 'OTH',
  sequence: 99
}, {
  countryName: 'South Korea',
  copyKey: 'COUNTRY_KR',
  isoCode: 'KR',
  regionCode: 'ASI',
  sequence: 99
}, {
  countryName: 'South Sudan',
  copyKey: 'COUNTRY_SS',
  isoCode: 'SS',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Spain',
  copyKey: 'COUNTRY_ES',
  isoCode: 'ES',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Sri Lanka',
  copyKey: 'COUNTRY_LK',
  isoCode: 'LK',
  regionCode: 'ASI',
  sequence: 99
}, {
  countryName: 'Sudan',
  copyKey: 'COUNTRY_SD',
  isoCode: 'SD',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Suriname',
  copyKey: 'COUNTRY_SR',
  isoCode: 'SR',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Svalbard and Jan Mayen Islands',
  copyKey: 'COUNTRY_SJ',
  isoCode: 'SJ',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Swaziland',
  copyKey: 'COUNTRY_SZ',
  isoCode: 'SZ',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Sweden',
  copyKey: 'COUNTRY_SE',
  isoCode: 'SE',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Switzerland',
  copyKey: 'COUNTRY_CH',
  isoCode: 'CH',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Syria',
  copyKey: 'COUNTRY_SY',
  isoCode: 'SY',
  regionCode: 'MID',
  sequence: 99
}, {
  countryName: 'Taiwan',
  copyKey: 'COUNTRY_TW',
  isoCode: 'TW',
  regionCode: 'ASI',
  sequence: 99
}, {
  countryName: 'Tajikistan',
  copyKey: 'COUNTRY_TJ',
  isoCode: 'TJ',
  regionCode: 'MID',
  sequence: 99
}, {
  countryName: 'Tanzania',
  copyKey: 'COUNTRY_TZ',
  isoCode: 'TZ',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Thailand',
  copyKey: 'COUNTRY_TH',
  isoCode: 'TH',
  regionCode: 'ASI',
  sequence: 99
}, {
  countryName: 'Togo',
  copyKey: 'COUNTRY_TG',
  isoCode: 'TG',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Tokelau',
  copyKey: 'COUNTRY_TK',
  isoCode: 'TK',
  regionCode: 'AUS',
  sequence: 99
}, {
  countryName: 'Tonga',
  copyKey: 'COUNTRY_TO',
  isoCode: 'TO',
  regionCode: 'AUS',
  sequence: 99
}, {
  countryName: 'Trinidad And Tobago',
  copyKey: 'COUNTRY_TT',
  isoCode: 'TT',
  regionCode: 'CAR',
  sequence: 99
}, {
  countryName: 'Tunisia',
  copyKey: 'COUNTRY_TN',
  isoCode: 'TN',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Turkey',
  copyKey: 'COUNTRY_TR',
  isoCode: 'TR',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Turkmenistan',
  copyKey: 'COUNTRY_TM',
  isoCode: 'TM',
  regionCode: 'ASI',
  sequence: 99
}, {
  countryName: 'Turks and Caicos Islands',
  copyKey: 'COUNTRY_TC',
  isoCode: 'TC',
  regionCode: 'CAR',
  sequence: 99
}, {
  countryName: 'Tuvalu',
  copyKey: 'COUNTRY_TV',
  isoCode: 'TV',
  regionCode: 'ASI',
  sequence: 99
}, {
  countryName: 'Uganda',
  copyKey: 'COUNTRY_UG',
  isoCode: 'UG',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Ukraine',
  copyKey: 'COUNTRY_UA',
  isoCode: 'UA',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'United Arab Emirates',
  copyKey: 'COUNTRY_AE',
  isoCode: 'AE',
  regionCode: 'MID',
  sequence: 99
}, {
  countryName: 'United Kingdom',
  copyKey: 'COUNTRY_GB',
  isoCode: 'GB',
  regionCode: 'EUR',
  sequence: 2
}, {
  countryName: 'United States',
  copyKey: 'COUNTRY_US',
  isoCode: 'US',
  regionCode: 'NAM',
  sequence: 3
}, {
  countryName: 'United States Minor Outlying Islands',
  copyKey: 'COUNTRY_UM',
  isoCode: 'UM',
  regionCode: 'NAM',
  sequence: 99
}, {
  countryName: 'Uruguay',
  copyKey: 'COUNTRY_UY',
  isoCode: 'UY',
  regionCode: 'SAM',
  sequence: 99
}, {
  countryName: 'Uzbekistan',
  copyKey: 'COUNTRY_UZ',
  isoCode: 'UZ',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Vanuatu',
  copyKey: 'COUNTRY_VU',
  isoCode: 'VU',
  regionCode: 'AUD',
  sequence: 99
}, {
  countryName: 'Vatican City State',
  copyKey: 'COUNTRY_VA',
  isoCode: 'VA',
  regionCode: 'EUR',
  sequence: 99
}, {
  countryName: 'Venezuela',
  copyKey: 'COUNTRY_VE',
  isoCode: 'VE',
  regionCode: 'SAM',
  sequence: 99
}, {
  countryName: 'Vietnam',
  copyKey: 'COUNTRY_VN',
  isoCode: 'VN',
  regionCode: 'ASI',
  sequence: 99
}, {
  countryName: 'Virgin Islands, British',
  copyKey: 'COUNTRY_VG',
  isoCode: 'VG',
  regionCode: 'CAR',
  sequence: 99
}, {
  countryName: 'Virgin Islands, US',
  copyKey: 'COUNTRY_VI',
  isoCode: 'VI',
  regionCode: 'CAR',
  sequence: 99
}, {
  countryName: 'Wallis and Futuna Islands',
  copyKey: 'COUNTRY_WF',
  isoCode: 'WF',
  regionCode: 'AUS',
  sequence: 99
}, {
  countryName: 'Western Sahara',
  copyKey: 'COUNTRY_EH',
  isoCode: 'EH',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Yemen',
  copyKey: 'COUNTRY_YE',
  isoCode: 'YE',
  regionCode: 'MID',
  sequence: 99
}, {
  countryName: 'Zaire',
  copyKey: 'COUNTRY_ZR',
  isoCode: 'ZR',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Zambia',
  copyKey: 'COUNTRY_ZM',
  isoCode: 'ZM',
  regionCode: 'AFR',
  sequence: 99
}, {
  countryName: 'Zimbabwe',
  copyKey: 'COUNTRY_ZW',
  isoCode: 'ZW',
  regionCode: 'AFR',
  sequence: 99
}
]
